export default __webpack_public_path__ + "static/media/banner-home12.77ce18c0.jpg";